import { ReactElement } from "react";
import styles from "./global-header-offset-provider.module.scss";
import classNames from "classnames";
import { useUserState, FreeTrialRole } from "@gx1/gx-npm-lib";

type GlobalHeaderOffsetProviderProps = {
  hasLeftNav: boolean
  hasGlobalHeader: boolean
  hasEvalHeader: boolean
  children: ReactElement | ReactElement[]
};

export const GlobalHeaderOffsetProvider = ({
  hasLeftNav, hasGlobalHeader, hasEvalHeader, children
}: GlobalHeaderOffsetProviderProps) => {
  const { freeTrialRole } = useUserState();
  const isFreeTrialUser = freeTrialRole === FreeTrialRole.FREE_TRIAL_GUEST || freeTrialRole === FreeTrialRole.FREE_TRIAL_RECIPIENT;

  return (
    <div
      className={classNames({
        [styles.hasLeftNav]: hasLeftNav,
        [styles.hasGlobalHeader]: hasGlobalHeader,
        [styles.hasEvalHeader]: hasEvalHeader,
        [styles.hasFreeTrialHeader]: isFreeTrialUser,
      })}
    >
      {children}
    </div>
  );
};
